<div class="container">
    <div class="row row-cards mt-5">
        <div class="card">
            <div class="table-responsive">
                <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                    <thead>
                        <tr class="text-center">
                            <th style="width: 3%;">#</th>
                            <th>Category</th>
                            <th>IPD</th>
                            <th>FeedBacks</th>
                            <th>BD Ratings</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center" *ngFor="let tdata of TotalCategorywiseIpdCounts; let index = index;">
                            <td style="width: 3%;">{{index+1}}</td>
                            <td>{{tdata.name}}</td>
                            <td>{{tdata.total_ipds}}</td>
                            <td>{{tdata.total_feedback}}</td>
                            <td>{{tdata.total_rating}}</td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>